import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';

import Skeleton from 'Storybook/core/Skeleton/Skeleton';

import styles from '../VehicleData.module.scss';

const SkeletonVehicleData: FC<{ className?: string; isAnimated?: boolean }> = ({ className, isAnimated = true }) => (
	<div className={styles.container}>
		<div className={cx(styles.basicThumbnail, styles.imageContainer)}>
			<Skeleton className={className} height={7} isAnimated={isAnimated} width={9} />
		</div>
		<div className={styles.textContainer}>
			<Skeleton className={className} isAnimated={isAnimated} width={10} />
			<Skeleton className={className} isAnimated={isAnimated} width={20} />
		</div>
	</div>
);
export default SkeletonVehicleData;
